import { useNavigate } from "react-router-dom";
import { IWhitespaceMenuItem, WhitespaceMenu } from "@whitespace/whitespace-ui";
import { useStateMachine } from "little-state-machine";

export const WhitespaceMenuWrapper = () => {
  const navigate = useNavigate();
  const { state } = useStateMachine();

  const logout = () => {
    navigate("/logout");
  };

  const items :IWhitespaceMenuItem[] = [];

  return (
    <>
      <WhitespaceMenu
        items={items}
        showLogout
        logoutHandler={logout}
        menuOpenHandler={() => {}}
        isMenuOpen
        displayUsername={state.username!}
        rootReturnUrl="/"
      />
    </>
  );
};
